import React from "react"
import styled from "@emotion/styled"

import AlertBanner from "../ui/alert-banner"
import WebpayBox from "./webpay-box"
import Webpay from "../ui/images/webpay-logo"
import WebpayBoxInternational from "./webpay-box-internacional"
import MercadoPago from "../ui/images/mercado-pago"
import PayBox from "./pay-box"

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
`

const Title = styled.h4`
  color: #1f2425;
  text-align: center;
  line-height: 140%;
`

const ContainerPayment = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
`

type Props = {
  international?: boolean
}

const PayOnline = ({ international = false }: Props) => {
  const WebpayWrapper = international ? WebpayBoxInternational : WebpayBox

  return (
    <Content>
      <Title>
        Depósito con tu tarjeta de crédito{!international && " o débito"}
      </Title>

      <AlertBanner>
        IMPORTANTE: En algunos casos podrá existir un costo por procesamiento de hasta un 2,5%, el cual será descontado del monto depositado.
      </AlertBanner>

      <ContainerPayment>
        <WebpayWrapper>
          <Webpay />
        </WebpayWrapper>

        <PayBox
          event="onboarding"
          url="https://onboarding.capitaria.com/deposit"
          styleBoxContent={{ width: "100%" }}
          styleBox={{ width: "217px" }}
        >
          <MercadoPago />
        </PayBox>
      </ContainerPayment>

    </Content>
  )
}

export default PayOnline
